import { IMG } from "./site";

const INST = { label: "LVP Installation" };
const CON = { label: "Contractors & Builders", href: "/contractors" };

const flooringRelated = [
  { label: "Luxury Vinyl Plank", href: "/flooring/luxury-vinyl-plank" },
  { label: "LVP Products & Prices", href: "/products" },
  { label: "LVP Installation", href: "/installation" },
  { label: "For Homeowners", href: "/homeowners" },
  { label: "Free Estimate", href: "/free-estimate" },
];
const contractorRelated = [
  { label: "Contractor Flooring", href: "/contractors/contractor-flooring" },
  { label: "Builder Flooring", href: "/contractors/builder-flooring" },
  { label: "Flooring Delivery", href: "/contractors/flooring-delivery" },
  { label: "Volume Pricing", href: "/contractors/volume-pricing" },
  { label: "Contractor Pricing Request", href: "/contractor-pricing" },
];

const CONTRACTOR_HIGHLIGHTS = [
  { title: "Wholesale Pricing", text: "Buy flooring without traditional retail channels or retail markups." },
  { title: "Volume Discounts", text: "Pricing that scales with square footage and repeat orders." },
  { title: "Jobsite Delivery", text: "Materials coordinated for delivery to your project whenever possible." },
  { title: "Product Availability", text: "Check stock and lead times before you commit to a schedule." },
  { title: "Repeat Purchasing", text: "Re-order the same products for the next phase or property." },
  { title: "New Construction", text: "Flooring supply for single homes, phases and subdivisions." },
  { title: "Renovation Projects", text: "Fast quotes and materials for remodels and turnovers." },
  { title: "Multi-Unit Projects", text: "Consistent flooring across apartments, rentals and portfolios." },
];

const floorPage = (slug, name, o) => ({
  path: `/flooring/${slug}`,
  crumbs: [{ label: name }],
  audience: "homeowner",
  process: "homeowner",
  related: flooringRelated.filter((r) => !r.href.endsWith(slug)),
  schema: { type: "Service", serviceType: `${name} flooring sales`, },
  ...o,
});

const conPage = (slug, name, o) => ({
  path: `/contractors/${slug}`,
  crumbs: [CON, { label: name }],
  audience: "contractor",
  process: "contractor",
  highlightsTitle: "What contractors get",
  highlights: CONTRACTOR_HIGHLIGHTS.slice(0, 4),
  related: contractorRelated.filter((r) => !r.href.endsWith(slug)),
  schema: { type: "Service", serviceType: "Wholesale flooring supply" },
  ...o,
});

export const LANDING_PAGES = [
  floorPage("luxury-vinyl-plank", "Luxury Vinyl Plank", {
    seo: { title: "Luxury Vinyl Plank Flooring | Wholesale LVP in Cornelius, NC", description: "Waterproof, durable luxury vinyl plank at wholesale pricing. LVP for homes, rentals, remodels and new construction around Lake Norman with installation available." },
    hero: { eyebrow: "Luxury Vinyl Plank", h1: "Luxury Vinyl Plank Flooring at Wholesale Prices", intro: "Durable, waterproof, attractive flooring designed for busy households, rental properties, renovations and new construction.", image: IMG.lvp, alt: "Luxury vinyl plank flooring in a bright vaulted great room" },
    highlightsTitle: "Why LVP works so well",
    highlights: [
      { title: "Waterproof options", text: "Ideal for kitchens, baths, laundry rooms and basements." },
      { title: "Built for traffic", text: "Wear layers that stand up to kids, pets and tenants." },
      { title: "Realistic wood looks", text: "Natural grain and tone in a wide range of colors." },
      { title: "Fast installation", text: "Floating click systems keep projects moving." },
    ],
    bulletsTitle: "Where LVP fits best",
    bullets: ["Whole-home flooring", "Kitchens & bathrooms", "Basements", "Rental & investment properties", "Remodels & flips", "New construction"],
    bulletsImage: IMG.kitchen,
    bulletsAlt: "Waterproof luxury vinyl plank flooring in a bright modern kitchen",
    categories: true,
  }),
  {
    path: "/installation",
    crumbs: [INST],
    audience: "homeowner",
    process: "homeowner",
    seo: { title: "LVP Installation in Lake Norman, NC | Luxury Vinyl Plank Installers", description: "Professional luxury vinyl plank installation with wholesale LVP pricing. Serving Cornelius, Huntersville, Denver, Sherrills Ford and Iron Station." },
    hero: { eyebrow: "LVP Installation", h1: "Professional LVP Installation", intro: "You don't just buy LVP from us. We handle the complete flooring experience, from estimate and selection to pricing and professional installation.", image: IMG.install, alt: "Installer fitting luxury vinyl planks in a new room" },
    highlightsTitle: "Why homeowners choose us for LVP installation",
    highlights: [
      { title: "One company, start to finish", text: "Buy your LVP and schedule installation through the same team." },
      { title: "Wholesale material pricing", text: "Save on LVP compared with traditional big-box pricing." },
      { title: "In-home estimates", text: "We measure, talk through options and price your project." },
      { title: "Flooring replacement", text: "Remove existing floors and replace them with new LVP." },
    ],
    related: [{ label: "Luxury Vinyl Plank", href: "/flooring/luxury-vinyl-plank" }, { label: "For Homeowners", href: "/homeowners" }, { label: "Free Estimate", href: "/free-estimate" }],
    schema: { type: "Service", serviceType: "Luxury vinyl plank installation" },
  },
  {
    path: "/homeowners",
    crumbs: [{ label: "Homeowners" }],
    audience: "homeowner",
    process: "homeowner",
    seo: { title: "Flooring for Homeowners | Wholesale Flooring + Installation", description: "Homeowners can buy flooring at wholesale pricing and have it professionally installed. Free in-home estimates across Lake Norman and greater Charlotte." },
    hero: { eyebrow: "For Homeowners", h1: "New Floors, Made Simple", intro: "Purchase your flooring and professional installation through one company, at wholesale pricing instead of big-box retail.", image: IMG.hero, alt: "Bright living room with wide-plank flooring" },
    highlightsTitle: "Homeowner services",
    highlights: [
      { title: "In-home estimates", text: "We measure and price your project at your home." },
      { title: "Selection assistance", text: "Help choosing the right floor for each room." },
      { title: "Professional LVP installation", text: "Clean, careful luxury vinyl plank installs." },
      { title: "Replacement & remodels", text: "Existing floor removal, remodel and whole-home flooring." },
    ],
    bulletsTitle: "We help with",
    bullets: ["In-home flooring estimates", "Flooring selection assistance", "Luxury vinyl plank installation", "Existing flooring replacement", "Remodel flooring", "Whole-home flooring", "Investment property flooring"],
    bulletsImage: IMG.living,
    bulletsAlt: "Living room with new wood-look luxury vinyl plank flooring",
    related: flooringRelated,
    schema: { type: "Service", serviceType: "Residential flooring installation" },
  },
  {
    path: "/contractors",
    crumbs: [CON],
    audience: "contractor",
    process: "contractor",
    seo: { title: "Flooring for Contractors & Builders | Wholesale Flooring Supplier", description: "Wholesale flooring distribution for contractors, builders, remodelers, investors and property managers. Volume pricing and jobsite delivery around Lake Norman." },
    hero: { eyebrow: "Contractor & Builder Program", h1: "Flooring for Contractors & Builders", intro: "Skip traditional retail channels. Use Wholesale LVP Flooring as your flooring distribution partner, with contractor pricing, volume discounts and jobsite delivery.", image: IMG.warehouse, alt: "Flooring warehouse with pallets and a yellow forklift" },
    highlightsTitle: "Built for the trade",
    highlights: CONTRACTOR_HIGHLIGHTS,
    bulletsTitle: "Who we supply",
    bullets: ["General contractors", "Home builders", "Remodelers", "Flooring installers", "Real estate investors", "Property managers", "Apartment operators", "Restoration contractors"],
    bulletsImage: IMG.construction,
    bulletsAlt: "New construction home interior ready for wholesale LVP flooring",
    audiences: true,
    related: contractorRelated,
    schema: { type: "Service", serviceType: "Wholesale flooring distribution" },
  },
  conPage("contractor-flooring", "Contractor Flooring", {
    seo: { title: "Contractor Flooring Supply | Wholesale Pricing Lake Norman, NC", description: "Contractor flooring at wholesale pricing with job-specific ordering and delivery across Lake Norman and greater Charlotte." },
    hero: { eyebrow: "Contractor Flooring", h1: "Contractor Flooring at Wholesale Pricing", intro: "Job-specific ordering, contractor pricing and repeat-order support for every project.", image: IMG.framing, alt: "Interior framing on a construction jobsite" },
  }),
  conPage("builder-flooring", "Builder Flooring", {
    seo: { title: "Builder Flooring Supplier | New Construction Flooring NC", description: "Flooring supply for home builders: wholesale LVP for new construction and multi-home phases around Lake Norman." },
    hero: { eyebrow: "Builder Flooring", h1: "Flooring Supply for Home Builders", intro: "Consistent product, pricing and delivery for spec homes, custom builds and phases.", image: IMG.construction, alt: "New construction home interior ready for flooring" },
  }),
  conPage("flooring-delivery", "Flooring Delivery", {
    seo: { title: "Jobsite Flooring Delivery | Lake Norman & Charlotte Area", description: "We bring the flooring to your jobsite. Flooring delivery coordinated for contractors in Huntersville, Cornelius, Denver, Sherrills Ford and Iron Station." },
    hero: { eyebrow: "Flooring Delivery", h1: "We Bring the Flooring to Your Jobsite", intro: "Purchase flooring directly and have materials coordinated for delivery to your project whenever possible.", image: IMG.forklift, alt: "Forklift moving pallets of building materials" },
    highlights: [CONTRACTOR_HIGHLIGHTS[2], CONTRACTOR_HIGHLIGHTS[3], CONTRACTOR_HIGHLIGHTS[4], CONTRACTOR_HIGHLIGHTS[7]],
  }),
  conPage("volume-pricing", "Volume Pricing", {
    seo: { title: "Volume Flooring Pricing for Contractors | Wholesale LVP Flooring", description: "Volume pricing on LVP for builders, investors and property managers with multi-property and repeat orders." },
    hero: { eyebrow: "Volume Pricing", h1: "Volume Pricing on Wholesale Flooring", intro: "Better pricing as your square footage grows, for single jobs, phases and portfolios.", image: IMG.warehouse, alt: "Warehouse racks stocked with flooring pallets" },
    highlights: [CONTRACTOR_HIGHLIGHTS[1], CONTRACTOR_HIGHLIGHTS[0], CONTRACTOR_HIGHLIGHTS[4], CONTRACTOR_HIGHLIGHTS[7]],
  }),
  conPage("general-contractors", "General Contractors", {
    seo: { title: "Flooring for General Contractors | Wholesale Supplier NC", description: "Wholesale flooring supply for general contractors: contractor pricing, job-specific orders and jobsite delivery around Lake Norman." },
    hero: { eyebrow: "General Contractors", h1: "Flooring Supply for General Contractors", intro: "One reliable flooring source for every job on your schedule.", image: IMG.framing, alt: "General contractor jobsite interior" },
  }),
  conPage("home-builders", "Home Builders", {
    seo: { title: "Flooring for Home Builders | Lake Norman Builder Supply", description: "Wholesale flooring for home builders with volume pricing and coordinated delivery for new construction around Lake Norman." },
    hero: { eyebrow: "Home Builders", h1: "Flooring for Home Builders", intro: "Wholesale flooring for spec homes, custom homes and new communities.", image: IMG.construction, alt: "New home under construction" },
  }),
  conPage("remodelers", "Remodelers", {
    seo: { title: "Flooring for Remodelers | Wholesale Flooring Lake Norman, NC", description: "Remodelers can source LVP at wholesale pricing with fast quotes and delivery." },
    hero: { eyebrow: "Remodelers", h1: "Wholesale Flooring for Remodelers", intro: "Fast quotes, product availability and wholesale pricing for remodel projects.", image: IMG.remodel, alt: "Remodel project with new plank flooring" },
  }),
  conPage("property-managers", "Property Managers", {
    seo: { title: "Flooring for Property Managers | Rental Flooring Supply NC", description: "Durable, consistent flooring for rentals and multi-unit properties with volume pricing and repeat ordering." },
    hero: { eyebrow: "Property Managers", h1: "Flooring for Property Managers", intro: "Durable flooring and repeat ordering for turnovers, rentals and multi-unit properties.", image: IMG.kitchen, alt: "Rental kitchen with waterproof vinyl plank" },
  }),
  conPage("real-estate-investors", "Real Estate Investors", {
    seo: { title: "Flooring for Real Estate Investors | Wholesale LVP NC", description: "Wholesale LVP and flooring for flips, rentals and portfolios around Lake Norman and Charlotte." },
    hero: { eyebrow: "Real Estate Investors", h1: "Flooring for Real Estate Investors", intro: "Protect your margins on flips and rentals with wholesale flooring pricing.", image: IMG.living2, alt: "Renovated living room ready to list" },
  }),
  conPage("flooring-installers", "Flooring Installers", {
    seo: { title: "Flooring for Installers | Wholesale Flooring Supplier Lake Norman", description: "Independent flooring installers can buy LVP at wholesale pricing with availability checks and delivery." },
    hero: { eyebrow: "Flooring Installers", h1: "Wholesale Flooring for Installers", intro: "Source material at wholesale pricing and keep your crews installing.", image: IMG.install2, alt: "Flooring installer at work" },
  }),
  {
    path: "/about",
    crumbs: [{ label: "About" }],
    audience: "homeowner",
    process: "homeowner",
    seo: { title: "About Wholesale LVP Flooring | Family Owned LVP Company in Cornelius, NC", description: "Wholesale LVP Flooring is a family owned and operated LVP supplier and installer in Cornelius, NC, owned by Chris Hartsell and CJ Hartsell." },
    hero: { eyebrow: "About Us · Family owned & operated", h1: "A Family-Owned LVP Company With Wholesale Pricing", intro: "Owned and operated by Chris Hartsell and CJ Hartsell, we help homeowners and contractors across Lake Norman get quality luxury vinyl plank without traditional retail markups.", image: IMG.oak, alt: "Luxury vinyl plank flooring in a bright Lake Norman home" },
    family: true,
    highlightsTitle: "What we stand for",
    highlights: [
      { title: "Wholesale prices", text: "Avoid traditional flooring retail markups." },
      { title: "Flooring expertise", text: "Help choosing the right floor for each home or project." },
      { title: "Local service", text: "Serving communities throughout Lake Norman." },
      { title: "Contractor friendly", text: "Wholesale and volume solutions for professionals." },
    ],
    related: [{ label: "Our Gallery", href: "/gallery" }, { label: "Service Areas", href: "/service-areas" }, { label: "Contact", href: "/contact" }],
    schema: { type: "AboutPage" },
  },
];

export const pageByPath = (path) => LANDING_PAGES.find((p) => p.path === path);
